import { useCallback, useEffect } from 'react';
import { useBlocker } from 'react-router-dom';

type UseFormDirtyStateOptions = {
  isDefaultValue: boolean;
  isEditMode: boolean;
};

export function useFormDirtyState({ isDefaultValue, isEditMode }: UseFormDirtyStateOptions) {
  const isDirty = isEditMode && !isDefaultValue;
  const blocker = useBlocker(isDirty);
  const isBlocked = blocker.state === 'blocked';

  useEffect(() => {
    if (!isDirty) return;
    const handler = (e: BeforeUnloadEvent) => e.preventDefault();
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [isDirty]);

  const handleLeaveWithoutSaving = useCallback(() => blocker.proceed?.(), [blocker]);
  const handleKeepEditing = useCallback(() => blocker.reset?.(), [blocker]);

  return {
    isDirty,
    showUnsavedChangesModal: isBlocked,
    handleLeaveWithoutSaving,
    handleKeepEditing,
  };
}
